export default __webpack_public_path__ + "dd7fe78583df9e747bd07fa51db45c66.png";